import { useState, useEffect } from 'react'

import { RichText } from '../../../common/components/rich-text'

import { textTableService } from './text-table.service'
import { useTableStyles } from './text-table.style'

export function TextTableBlock (props) {
  const classes = useTableStyles()

  const [table, setTable] = useState()

  useEffect(() => {
    const transformedData = textTableService.transformBlockDataToLayout(props)
    setTable(transformedData)
  }, [])

  if (!table) {
    return null
  }

  return (
    <div className={classes.table}>
      <div className={classes.header}>
        {table.header && table.header.map((cell) => (
          <RichText key={cell.key} className={classes.headerCell} style={{ width: cell.width }} value={cell.delta} />
        ))}
      </div>
      {table.data && table.data.map(({ key, row }) => (
        <div key={key} className={classes.row}>
          {row.map((cell) => (
            <RichText key={cell.key} className={classes.dataCell} value={cell.delta} />
          ))}
        </div>
      ))}
    </div>
  )
}
